module.exports = __webpack_public_path__ + "static/media/Kent Kitchen  (6) - Copy.f8e2c809.JPG";